import { useSelector } from 'react-redux';
import { AppState } from '../../types/redux/AppState';


export const useWolfTracsState = <TState>(selector: (state: AppState) => TState) => {
    const result = useSelector<AppState, TState>(selector);
    return result;
};